import {Navigate} from "react-router-dom";
import {Container, Divider, Stack} from "@mantine/core";
import {useConfig} from "../ConfigContext";
import {VentureHero, renderSection} from "../components/venture/VentureSections";

/**
 * One renderer for all venture landing pages. The page's shape comes entirely
 * from `venture.sections` in portalConfig, so each venture can lead with a
 * different block while sharing the same visual language.
 */
const VentureLanding = ({slug}: { slug: string }) => {
    const {ventures} = useConfig();
    const venture = ventures.find((candidate) => candidate.slug === slug);

    if (!venture) {
        return <Navigate to="/ventures" replace/>;
    }

    return (
        <Container size="xl" py="xl">
            <Stack gap={64}>
                <VentureHero
                    name={venture.name}
                    tagline={venture.tagline}
                    summary={venture.summary}
                    icon={venture.icon}
                    status={venture.status}
                    website={venture.website}
                />
                <Divider/>
                {venture.sections.map((section, index) => renderSection(section, index))}
            </Stack>
        </Container>
    );
};

export default VentureLanding;
